import { DateTime } from "luxon";
import { AuditLogField } from "src/app/modules/core/decorators/decorators";

export interface ISiteProtocolDtoModelData {
  result: SiteProtocolDto[];
}

export interface ISiteProtocolModelData {
  result: SiteProtocolDto;
}

export class SiteProtocolDto {
  id!: number | undefined | null;
  siteId!: number | undefined | null;
  @AuditLogField
  siteProtocolTypeId!: number | undefined | null;
  steps!: SiteProtocolStepDto[] | undefined | null;
  @AuditLogField
  escalationTypeIds!: number[] | undefined | null;
  @AuditLogField
  isActive!: boolean | undefined | null;
}

export class SiteProtocolStepDto  {
  id!: number | undefined | null;
  @AuditLogField
  siteProtocolId!: number | undefined | null;
  @AuditLogField
  siteProtocolStepTypeId!: number | undefined | null;
  @AuditLogField
  order!: number | undefined;
  @AuditLogField
  fromTime!: string | undefined | null;
  @AuditLogField
  toTime!: string | undefined | null;
  callTree!: SiteProtocolContactDto[] | undefined | null;
  @AuditLogField
  isActive!: boolean | undefined;
  @AuditLogField
  isCallAll!: boolean | undefined;
  @AuditLogField
  isCallUntil!: boolean | undefined;
  @AuditLogField
  allowedDays: string | undefined;
  allowedDaysCheckList: AllowedDaysCheckListModel; //OBSOLETE
}

export class SiteProtocolContactDto {
  id!: number | undefined | null;
  siteProtocolStepId!: number | undefined | null;
  phonePriority!: number | undefined | null;
  contactId!: number | undefined | null;
  isPerson!: boolean | undefined | null;
  isActive!: boolean | undefined | null;
  siteProtocolContactType: number | undefined | null;
  contactSchedules: SiteProtocolContactSchedule[] | undefined;
  fromTime!: string | undefined | null;
  toTime!: string | undefined | null;
  allowedDays: string | undefined | null;
}

export class SiteProtocolContactSchedule {
  fromTime!: string | undefined | null;
  toTime!: string | undefined | null;
  allowedDays: string | undefined | null;
}

export class AllowedDaysCheckListModel {
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
}

export class SiteProtocolStepTypeDto {
  id: number;
  name: string;
  description: string;
  allowTime: boolean;
  allowAuthoritiesContact: boolean;
  allowCustomerContact: boolean;
  allowStealthContact: boolean;
  isActive: boolean;
  createdBy: number;
  createdDate: DateTime;
  updatedBy: number;
  updatedDate: DateTime;

  actions: SiteProtocolStepTypeActionDto[];
}

export class SiteProtocolStepTypeActionDto {
  siteProtocolStepTypeId: number;
  actionOutcomeTypeLookupId: number;
  actionOutcomeTypeId: number;
  actionRemarks: SiteProtocolStepTypeActionRemarkDto[];
  isActive: boolean;
  createdBy: number;
  createdDate: DateTime;
  updatedBy: number;
  updatedDate: DateTime;
}

export class SiteProtocolStepTypeActionRemarkDto {
  siteProtocolStepTypeId: number;
  actionOutcomeTypeLookupID: number;
  actionOutcomeTypeID: number;
  actionOutcomeRemarkTypeLookupID: number;
  actionOutcomeRemarkTypeID: number;
  isActive: boolean;
  isReviewRequired: boolean;
  createdBy: number;
  createdDate: DateTime;
  updatedBy: number;
  updatedDate: DateTime;
}

export interface SiteProtocolParameter {
  siteId: number;
  search?: string;
  priorityTypeIds?: number[];
  isActive?: boolean;
  sorting?: string;
}

export interface SiteProtocolTableDto {
  id?: number; 
  siteId: number;
  siteProtocolTypeId: number;
  escalationTypeId: number;
  escalationTypeName: string;
  priorityTypeId?: number;
  steps: SiteProtocolStepDto[];
  isActive: boolean;
  createdBy?: number;
  createdDate?: Date | string;
  updatedBy?: number;
  updatedDate?: Date | string;
}

// #region Bulk  Update Site Protocol
export interface BulkSiteProtocolUpdateDto {
  siteId: number;
  escalationTypeIds: number[];
  siteProtocolStepTypeId: number;
  isPerson: boolean;
  steps: ProtocolStepContactChangesDto;
  updatedBy?: number | null;
  updatedDate?: string | null;
}

export interface ProtocolStepContactChangesDto {
  isCallAll: boolean;
  isCallUntil: boolean;
  contacts: BulkProtocolContactDto[];
}

export interface BulkProtocolContactDto {
  contactId: number;
  siteProtocolContactType: number;
  phonePriority: number;
  contactSchedules: SiteProtocolContactScheduleDto[];
}

export interface SiteProtocolContactScheduleDto {
  fromTime: string;
  toTime: string;
  allowedDays: string;
}

export interface BulkProtocolStepContactUpdateResultDto {
  totalCount: number;
  successCount: number;
  failureCount: number;
  results: BulkProtocolStepContactUpdateItemResultDto[];
}

export const emptyBulkProtocolStepContactUpdateResultDto: BulkProtocolStepContactUpdateResultDto = {
  totalCount: 0,
  successCount: 0,
  failureCount: 0,
  results: [],
};

export interface BulkProtocolStepContactUpdateItemResultDto {
  escalationTypeId: number;
  siteProtocolStepId?: number | null;
  success: boolean;
  errorCode?: string | null;
  errorMessage?: string | null;
}
// #endregion Bulk  Update Site Protocol